<template>
  <div v-if="pog">
    <v-toolbar dark>
      <v-toolbar-title>
        {{ toolbarTitle }}
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-btn v-if="contactView" @click="contactView = !contactView" flat>
        <v-icon>timelapse</v-icon>&nbsp; Key Milestones
      </v-btn>
      <v-btn v-else @click="contactView = !contactView" flat>
        <v-icon>contact_mail</v-icon>&nbsp; Info
      </v-btn>
      <v-btn @click="$emit('close')" flat>
        <v-icon>close</v-icon>&nbsp; exit
      </v-btn>
    </v-toolbar>

    <v-card dark>
      <v-progress-linear
        color="black"
        indeterminate
        v-if="dataLoading"
        height="1"
      ></v-progress-linear>
      <v-layout>
        <v-flex sm12 md6>
          <v-card flat>
            <v-img
              height="600"
              v-show="imageIndex === -1"
              :src="
                coverPhoto
                  ? coverPhoto
                  : require('@/assets/images/lazy_pog.jpg')
              "
              gradient="to top, rgba(0,0,0,.6), rgba(0,0,0,.6)"
              :lazy-src="require('@/assets/images/lazy_pog.jpg')"
            >
              <v-container fill-height>
                <v-layout align-center>
                  <strong class="display-4 font-weight-regular mr-4">{{
                    pog.start ? pog.start.split("-")[0] : ""
                  }}</strong>
                  <v-layout column justify-end>
                    <div class="headline font-weight-light">
                      {{ pog.start ? pog.start.split("-")[1] : "" }}
                    </div>
                    <div class="text-uppercase font-weight-light">
                      {{ pog.start ? pog.start.split("-")[2] : "" }}
                    </div>
                  </v-layout>
                </v-layout>
              </v-container>
              <div v-if="photos.length > 0" class="image-nav-forward">
                <v-btn icon @click="incrementImages(true)"
                  ><v-icon>arrow_forward_ios</v-icon></v-btn
                >
              </div>
            </v-img>

            <v-layout
              v-show="imageIndex >= 0"
              v-for="(image, index) in photos"
              :key="index"
            >
              <v-flex>
                <v-img
                  v-show="imageIndex === index"
                  height="600"
                  :src="image.url"
                  :lazy-src="require('@/assets/images/lazy_pog.jpg')"
                  gradient="to bottom, rgba(0,0,0,0), rgba(0,0,0,0), rgba(0,0,0,0), rgba(0,0,0,1)"
                >
                  <template v-slot:placeholder>
                    <v-layout fill-height align-center justify-center ma-0>
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-layout>
                  </template>
                  <div
                    v-if="imageIndex < photos.length - 1"
                    class="image-nav-forward"
                  >
                    <v-btn icon @click="incrementImages(true)"
                      ><v-icon>arrow_forward_ios</v-icon></v-btn
                    >
                  </div>
                  <div class="image-nav-backward">
                    <v-btn icon @click="incrementImages(false)"
                      ><v-icon>arrow_back_ios</v-icon></v-btn
                    >
                  </div>
                  <v-container fill-height>
                    <v-layout column justify-end class="text-xs-right">
                      <!-- <div class="font-weight-light">
                        {{
                          `Added ${
                            pog.photos[index] ? pog.photos[index].date : "-"
                          }`
                        }}
                      </div> -->
                      <div class="font-weight-light">
                        {{ photos[index].comment }}
                      </div>
                    </v-layout>
                  </v-container>
                </v-img>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex sm12 md6>
          <v-card dark flat class="scroll" max-height="600">
            <v-card-text>
              <v-container fill-height v-if="contactView && pog.contact">
                <v-card-text class="text-lg-center">
                  <v-icon size="75">{{ icons[pog.type] }}</v-icon
                  >&nbsp;<strong class="display-3 font-weight-regular mr-4">{{
                    pog.type
                  }}</strong>
                  <h2 class="font-weight-light">
                    {{ pog.contact.organization }}
                  </h2>
                  <h4 class="font-weight-light">{{ pog.contact.email }}</h4>
                  <h4 class="font-weight-light">{{ pog.contact.phone }}</h4>
                  <br />
                  <v-divider></v-divider>
                  <v-layout>
                    <v-flex sm12 md6>
                      <h3>Activities</h3>
                      <br />
                      <v-chip
                        class="font-weight-light"
                        v-for="(item, index) in pog.activity"
                        :key="index"
                      >
                        {{ item }}
                      </v-chip>
                    </v-flex>
                    <v-divider vertical></v-divider>
                    <v-flex sm12 md6>
                      <h3>
                        {{
                          pog.partners.length > 0
                            ? "Partners"
                            : "No current partners"
                        }}
                      </h3>
                      <br />
                      <v-chip
                        class="font-weight-light"
                        v-for="(item, index) in pog.partners"
                        :key="index"
                      >
                        {{ item }}
                      </v-chip>
                    </v-flex>
                  </v-layout>
                  <v-divider></v-divider>
                  <v-layout>
                    <v-flex sm8 offset-sm2 class="pt-3">
                      <h3 class="font-weight-light">{{ infoText }}</h3>
                      <br />
                      <div class="font-weight-light">{{ pog.description }}</div>
                      <br />
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-container>
              <comment-pog v-else :comments="this.pog.comments"> </comment-pog>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import { getPOGPhoto } from "@/api/map";
import CommentPOG from "@/components/pog/CommentPOG";

export default {
  name: "ViewPOG",

  components: {
    "comment-pog": CommentPOG,
  },

  props: {
    pog: Object,
    pogUpdated: Boolean,
  },

  data() {
    return {
      dataLoading: false,
      imageIndex: -1,
      contactView: true,
      photos: [],

      icons: {
        "Restoration/Enhancement": "rotate_left",
        Conservation: "eco",
        "Awareness/Education": "share",
      },
    };
  },

  computed: {
    user() {
      return this.$store.state.settings.user;
    },
    adminUsers() {
      return this.$store.state.settings.adminUsers;
    },
    coverPhoto() {
      if (this.photos.length === 0) return null;
      else if (!this.photos[0].x) return this.photos[0].url;
      else {
        const x = Math.min(...this.photos.map((p) => p.x));
        const y = Math.min(...this.photos.map((p) => p.y));

        return this.photos.filter((p) => {
          return p.x === x && p.y === y;
        })[0].url;
      }
    },
    toolbarTitle() {
      if (this.pog) {
        if (this.user && this.adminUsers.includes(this.user.username))
          return `${this.pog.name} (${this.pog.createdByUser} ${this.pog.id +
            1})`;
        else return this.pog.name;
      } else {
        this.$emit("show-message", "Project not found", "red");
      }
      return null;
    },

    infoText() {
      return `This project${this.pog.size ? " of " : ""}${
        this.pog.size ? this.pog.size : ""
      } ${this.pog.size ? this.pog.sizeType : ""} was started on ${
        this.pog.start
      } ${this.pog.timeline ? ", and is expected to take" : ""} ${
        this.pog.timeline ? this.pog.timeline : ""
      } ${
        this.pog.timeline
          ? parseInt(this.pog.timeline) === 1
            ? this.pog.timelineType.slice(0, -1)
            : this.pog.timelineType
          : ""
      }.`;
    },
  },

  watch: {
    pogUpdated() {
      this.loadData();
    },
  },

  methods: {
    loadData() {
      this.imageIndex = -1;
      this.contactView = true;

      this.photos = [];

      if (this.pog.photos) {
        this.dataLoading = true;

        Promise.all(
          this.pog.photos.map((photo, idx) => {
            return getPOGPhoto(this.pog, photo.i ? photo.i : idx);
          })
        )
          .then((tempLinks) => {
            this.photos = tempLinks.map((tempLink, idx) => {
              return { ...this.pog.photos[idx], url: tempLink };
            });
          })
          .finally(() => {
            this.dataLoading = false;
          });
      }
    },

    incrementImages(forwards) {
      forwards ? this.imageIndex++ : this.imageIndex--;
    },
  },

  beforeMount() {
    this.loadData();
  },
};
</script>

<style scoped>
.scroll {
  overflow-y: auto;
}
.image-nav-forward {
  position: absolute;
  right: 20px;
  bottom: 10%;
  margin: auto;
}

.image-nav-backward {
  position: absolute;
  left: 20px;
  bottom: 10%;
  margin: auto;
}
</style>
